const variantColor = (theme, variant) => {
    const palette = {
        accent: theme.accent,
        secondary: theme.secondary,
        tertiary: theme.tertiary,
        success: theme.success,
        danger: theme.danger,
        warning: theme.warning,
        neutral: theme.bgDark
    };

    return palette[variant] || theme.accent;
};

export const getButtonStyle = (theme, options = {}) => {
    const {
        variant = 'accent',
        disabled = false,
        outline = false,
        padding = '10px 14px',
        borderRadius = '8px'
    } = options;

    const variantBg = variantColor(theme, variant);
    const borderColor = disabled ? theme.textDisabled : (outline ? theme.light : variantBg);
    const backgroundColor = outline ? 'transparent' : (disabled ? theme.textDisabled : variantBg);

    return {
        padding,
        borderRadius,
        border: `2px solid ${borderColor}`,
        backgroundColor,
        color: theme.textPrimary,
        fontFamily: 'inherit',
        fontWeight: 'bold',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.72 : 1,
        transition: 'filter 0.2s ease, transform 0.2s ease'
    };
};

export default getButtonStyle;
